

export enum ApiError {
    UNAUTHORIZED,
    SERVER_ERROR,
}

export function useApiError(error?: any): {
    error: ApiError,
    message: string,
    details: string
} | undefined {

    if (error) {
        console.error(error)
        if (error.status === 401) {
            return { error: ApiError.UNAUTHORIZED, message: "Unauthorized", details: error.message };
        }
        return { error: ApiError.SERVER_ERROR, message: "Server Error", details: error.message };
    }

    return undefined
}